<template>
  <div
      :id="buttonId"
      :class="[
            'vform-slide-control-element vform-button-item',
            invisible ? 'invisible' : '',
            goNextBlocked ? 'go-next-blocked' : '',
            config.bottomDropZone ? 'mb-0' : '',
            tiles ? 'vform-tiles' : '',
            inline ? 'inline-button no-margin-bottom' : '',
            !tiles ? config.alignment : '',
            'border-radius', 'multi-line',
            numOfElementsInZone && numOfElementsInZone > 1 ? 'col-'+getDropzoneCol() : '',
            !disabled && !state.dragging && !editorMode && !goNextBlocked ? 'button-hover-effect' : 'no-button-hover-effect',
            editing ? 'position-relative' : ''
        ]"
      :style="{
            flex: config.bottomDropZone ? '0 0 ' + getDropzoneWidth() + '%' : '',
            minHeight: computedMinHeight,
            backgroundColor: tiles && config.backgroundColor ? config.backgroundColor : '',
            color: config.fontColor ? config.fontColor : (fontColor ? fontColor : ''),
        }"
      @click="click"
      @mouseenter="tiles && !state.dragging && !disabled && !editorMode ? setColors(buttonId) : () => {}"
      @mouseleave="tiles && !state.dragging && !disabled && !editorMode ? unsetColors(buttonId) : () => {}"
  >
    <div
        v-if="editorMode"
        :style="dropzoneStyle"
        class="w-100 position-absolute full-height">
      <slot name="dropzone"></slot>
    </div>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :has-template="!!config.templateId"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
        @removeBlock="$emit('removeBlock')"
    />
    <div
        v-if="tiles"
        :class="[
                'inner d-flex border-radius',
                !disabled && !state.dragging && !editorMode ? 'clickable' : 'no-button-hover-effect',
                'p-2 vform-button-tiles',
                config.bottomDropZone ? 'next-button' : '',
                config.textAlignment ? `text-align-${config.textAlignment}` : '',
            ]"
        :style="{
                'justify-content': 'center',
                'flex-direction' : 'column',
                 borderColor: config.borderColor ? config.borderColor : '#000'
            }"
    >
      <preview
          :key="forceReRenderKey + 'preview'"
          v-if="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :asset-id="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :background-mode="false"
          :img-auto-shrink-to-fit="true"
          :may-load-now="isActive"
          :offline-mode="offlineMode"
          :preview-id="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :removable="false"
          :show-spinner-message="false"
          :size="config.iconSize"
          class="tile-button-image-wrapper text-center"
          classes="square-image"
          source="asset"
          spinner-size="default"
          @contentLoaded="increaseCounter"
      />
      <div :class="['tile-button-label']">{{getLabel(config, this.$store.getters.getSelectedFormLanguage) ? getLabel(config, this.$store.getters.getSelectedFormLanguage) : $t("next") }}</div>
    </div>
    <div
        v-else
        :class="[
                'vform-button-no-tiles',
                !disabled && !state.dragging && !editorMode ? 'clickable' : 'no-button-hover-effect',
                invisible ? 'invisible' : '',
                config.bottomDropZone ? 'next-button' : 'simple-button',
                config.alignment,
                config.textAlignment ? `text-align-${config.textAlignment}` : ''
            ]"
        :style="{
              backgroundColor: config.backgroundColor ? config.backgroundColor : '',
              borderColor: config.borderColor ? config.borderColor : '#000',
              color: config.fontColor ? config.fontColor : (fontColor ? fontColor : '')
          }"
        @mouseenter="!state.dragging ? setColors(buttonId) : () => {}"
        @mouseleave="!state.dragging ? unsetColors(buttonId) : () => {}"
    >
      <preview
          :key="forceReRenderKey + 'preview2'"
          v-if="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :asset-id="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :background-mode="false"
          :may-load-now="isActive"
          :offline-mode="offlineMode"
          :preview-id="getImage(config, this.$store.getters.getSelectedFormLanguage)"
          :removable="false"
          :show-spinner-message="false"
          :class="['', panelDir === 'rtl' ? 'ml-2' : 'mr-2']"
          size="fit-content"
          source="asset"
          spinner-size="default"
          @contentLoaded="increaseCounter"
      />
      <div class="non-preview d-flex">
        <template
          v-if="(config.buttonStyle === 'Arrow' || config.buttonStyle === 'TextAndIcon') && (config.iconPos && config.iconPos === 'iconLeft')">
          <div :class="['outer-icon', config.buttonStyle === 'TextAndIcon' ? (panelDir === 'ltr' ? 'mr-2' : 'float-left ml-2') : '']">
            <icon size="1" class="d-inline-block full-height align-items-center" injected-svg-class="d-inline-flex" :type="getIcon"  />
        </div>
      </template>
      <div
          v-if="!config.buttonStyle ||  config.buttonStyle === 'Text' || config.buttonStyle === 'TextAndArrow' || config.buttonStyle === 'TextAndIcon'"
          :class="['text wrap-break', getImage(config, this.$store.getters.getSelectedFormLanguage) ? 'with-icon' : 'without-icon']">
        <!--DO NOT ADD A LINE BREAK BEFORE GETLABEL OR YOU WILL HAVE A SPACE AT THE BEGINNING!!-->{{ getLabel(config, this.$store.getters.getSelectedFormLanguage) ? getLabel(config, this.$store.getters.getSelectedFormLanguage) : $t("next") }}
      </div>
      <template
          v-if="(config.buttonStyle === 'Arrow' || config.buttonStyle === 'TextAndIcon') && (!config.iconPos || config.iconPos === 'iconRight')">
          <div :class="['outer-icon', config.buttonStyle === 'TextAndIcon' ? (panelDir === 'ltr' ? 'ml-2' : 'float-right mr-2') : '']">
            <icon size="1" class="d-inline-block full-height align-items-center" injected-svg-class="d-inline-flex" :type="getIcon" />
        </div>
      </template></div>
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import ColorContrastMixinJs from "../../mixins/ColorContrastMixin.js";
import Preview from "./Preview";
import EditorOverlay from "./EditorOverlay";
import Icon from "@/components/Icon";
//import listenerMixinJs from "@/components/mixins/listenerMixin.js.vue";
export default {
  name: "BUTTON_ITEM",
  components: {
    Preview,
    EditorOverlay,
    Icon
  },
  mixins: [ElementMixin, ColorContrastMixinJs],
  props: {
    invisible: {type: Boolean, default: false},
    numOfElementsInZone: {type: Number, default: 1},
    goNextBlocked: {type: Boolean, default: false},
  },
  data() {
    return {
      tiles: false,
      buttonId: null,
      counterIncreased: false,
      computedMinHeight: '',
    };
  },
  computed: {
    inline() {
      return this.config.isInline === true;
    },
    dropzoneStyle() {
      if(this.inline) {
        return {
          left: '-3px',
          top: '4px'
        }
      }
      return {
        top: '-5px',
      }
    },
    getIcon() {
      // Arrow style always uses the angle icon regardless of any configured icon
      let icon = this.config.buttonStyle === 'Arrow' ? 'angle-right' : this.config.icon;
      if(!icon) {
        if(this.config.buttonStyle === 'TextAndIcon') {
          icon = 'angle-right';
        } else {
          return null;
        }
      }
      if(this.panelDir === 'rtl') {
        if(icon.includes('right')) {
          icon = icon.replace('right', 'left');
        } else if(icon.includes('left')) {
          icon = icon.replace('left', 'right');
        }
      }
      return icon;
    }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.tiles = this.isTiles(this.config);
        this.checkColors();
        this.computeHeight();
        this.forceReRenderKey++;
      },
    },
  },
  beforeMount() {
    this.tiles = this.isTiles(this.config);
    this.migrateOldButtons();
    this.buttonId = 'button' + this.config.uuid;
    this.computeHeight();
  },
  mounted() {
    if (!this.getImage(this.config, this.$store.getters.getSelectedFormLanguage)) {
      this.increaseCounter();
    }
    this.checkColors();
    // Recompute height after the DOM is fully painted (slideshow-div may not exist in beforeMount)
    this.$nextTick(() => {
      this.computeHeight();
    });
  },
  methods: {
    migrateOldButtons() {
      this.config.aligment = this.config.aligment ? this.config.aligment : 'right';
      if(this.config.buttonStyle === 'TextAndArrow') {
        this.$set(this.config, "buttonStyle", "TextAndIcon");
        this.$set(this.config, "icon", "angle-right");
      }
    },
    /*setUpResizeListener() {
      const el = document.getElementById('slideshow-div');
      this.addListener(el, 'resize', this.computeHeight, 'slideshow-resize');
    },*/
    computeHeight() {
      // todo: the slideshow component should calculate its own height and provide this as a reactive variable instead
      const {height, buttonSizeMode, showastiles} = this.config;

      // Reset
      this.computedMinHeight = '';

      if (!showastiles || !height || height === 'auto' || buttonSizeMode === 'auto') {
        return;
      }

      // Legacy buttons without buttonSizeMode default to minheight behaviour
      const slideShowDiv = document.getElementById('slideshow-div');
      if (slideShowDiv) {
        const slideShowHeight = slideShowDiv.clientHeight;
        this.computedMinHeight = slideShowHeight / 100 * (height / 2) + 'px';
      } else {
        this.computedMinHeight = (height / 2) + '%';
      }
    },
    getDropzoneWidth() {
      return Math.floor((100 / this.numOfElementsInZone) - 1);
    },
    getDropzoneCol() {
      return Math.floor(12 / this.numOfElementsInZone);
    },
    checkColors() {
      this.setInitialColors(this.buttonId);
    },
    getJumpTarget() {
      return this.getJumpTargets();
    },
    click() {
      if (this.clicking || this.goNextBlocked) {
        return;
      }
      this.clicking = true;
      console.log('BUTTON click', this.config);
      this.handleGoTo(this.config);
      const $this = this;
      setTimeout(() => {
        $this.clicking = false;
      }, 100);
    },
  }
}
</script>

<style lang="scss">
.vform-button-item {
  .vform-image-display {
    svg {
      width: 100%;
      justify-self: end;
      flex-shrink: 0;
      flex-grow: 0;
      min-width: 20px;
    }
    img {
      width: 100%;
      height: 100%;
      flex-shrink: 0;
      flex-grow: 0;
      min-width: 20px;
    }
  }
  .vform-button-tiles {
    border: 1px solid #000;
    .vform-the-preview {
      width: 100%;
      height: 100%;
      display: flex;
      margin: auto;
      align-items: center;
      justify-content: center;
      .vform-image-preview {
        padding-top: 0;
        padding-bottom: 0;
      }
      img, svg {
        max-width: 100%;
        max-height: 100%;
      }
      svg {
      }
    }
    &.justify {
      .tile-button-label {
        width: 100%;
        justify-content: center;
      }
    }
    &.text-align-center {
     .tile-button-label {
       text-align: center;
       justify-content: center;
     }
    }
    &.text-align-right {
      .tile-button-label {
        text-align: right;
        justify-content: end;
      }
    }
  }
  .vform-button-no-tiles {
    border: 1px solid #000;
    border-radius: 3px;
    display: inline-flex;
    align-items: center;
    .non-preview {
      flex-grow: 0;
      align-items: center;
      display: inline-block;
    }
    .vform-the-preview {
      width: 2.5em;
      min-width: 2.5em;
      height: 1.8em;
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      img {
        flex-shrink: 0;
        flex-grow: 0;
        display: inline-block;
        width: 100%;
        height: auto;
      }
    }
    &.justify {
      width: 100%;
      .non-preview {
        width: 100%;
        justify-content: space-between;
      }
    }
    &.text-align-center {
      justify-content: center;
    }
    &.text-align-right {
      justify-content: flex-end;
    }
  }
}
</style>

<style lang="scss" scoped>
.outer-icon {
  align-items: center;
  display: inline-flex;
}
.invisible {
  opacity: 0;
  pointer-events: none;
}
.go-next-blocked {
  opacity: 0.2;
  pointer-events: none;
}

.with-icon {
  flex-grow: 1 !important;
}

.wrap-break {
  text-wrap: wrap;
  overflow-wrap: anywhere;
}

.tile-button-label {
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
</style>
